import { useEffect, useState } from "react";

/**
 * Hora atual (ms) que vira junto com o segundo do relógio — não 1 s depois
 * de montar. Assim o anel do código troca no mesmo instante que o app
 * autenticador do celular.
 */
export default function useSegundoAtual() {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    let id = 0;
    const agendar = () => {
      id = window.setTimeout(() => {
        setAgora(Date.now());
        agendar();
      }, 1000 - (Date.now() % 1000) + 5);
    };
    agendar();
    return () => window.clearTimeout(id);
  }, []);
  return agora;
}
